module.exports = __webpack_public_path__ + "img/offline.bbe7d617.png";